// SCHOOL-SPECIFIC — Heguru. See src/config/school.js for how a brand is chosen.
export const heguru = {
  key: 'heguru',
  name: 'Heguru',
  appName: 'Library',

  // Feeds member and copy codes (HEG-B1-000123). MUST match app_config.short_code
  // in THIS brand's database. Changing it after labels are printed invalidates
  // every label.
  shortCode: 'HEG',

  // Only used to build the example in the "scan or type a book code" hint —
  // staff type what the hint shows, so it has to look like a real code here.
  exampleBranchCode: 'B1',

  // Branch name used by demo mode (VITE_MOCK) — screenshots and walkthroughs.
  demoBranchName: 'U Wisara Branch',

  currency: 'MMK',
  timezone: 'Asia/Yangon',   // must match today_local() in the database (§2.5)

  // The address staff type to reach THIS school's app. See happee.js.
  //
  // This is the raw Cloudflare Pages hostname — Heguru has no custom domain
  // yet. If one is added later, CHANGE IT HERE and reissue the guide: staff
  // who installed the app from this address keep pointing at it, and the fix
  // is to delete that icon and add it again from the new one (DEPLOY.md).
  liveUrl: 'heguru-library.pages.dev',

  brand: {
    // Sampled from this brand's logo.png — 38% of its pixels.
    // Re-sample after any logo change with: npm run brand:color
    color: '#f57b20',

    // The wordmark black, also sampled. Headings, and the readable text colour
    // on the brand orange (white on orange fails WCAG — see lib/theme.js).
    ink: '#231f20',

    logo:  '/brand/heguru/logo.png',
    mark:  '/brand/heguru/mark.png',
    icons: '/icons/heguru',

    // The lockup is the symbol above the wordmark, so a header mark can be
    // cropped out of it automatically by `npm run gen:icons`.
    generateMark: true,
  },
};
